import { useState, useEffect } from 'react';
import { META, ROUTES } from './data';

export default function Header({ page, setPage }) {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => { const h = () => setScrolled(window.scrollY > 30); window.addEventListener('scroll', h, { passive: true }); return () => window.removeEventListener('scroll', h); }, []);
  return (
    <header className={`fixed top-0 inset-x-0 z-40 transition-all ${scrolled ? 'bg-[#F0EBE0]/95 backdrop-blur-md py-3' : 'bg-[#F0EBE0] py-5'}`}>
      <div className="max-w-[1500px] mx-auto px-8 lg:px-14 grid grid-cols-[auto_1fr_auto] items-center gap-8">
        <button onClick={() => setPage('home')} data-testid="vsp-logo" className="text-left">
          <p className="font-mono text-[9px] tracking-[0.4em] uppercase text-[#1B2D8C]">— Studio · Est. {META.est}</p>
          <p className="font-serif italic text-[26px] leading-none text-[#1B2D8C]">{META.brand}</p>
        </button>
        <nav className="hidden md:flex items-center justify-center gap-7">
          {ROUTES.map(r => (
            <button key={r.id} onClick={() => setPage(r.id)} data-testid={`vsp-nav-${r.id}`} className={`group flex items-baseline gap-1.5 transition-colors ${page === r.id ? 'text-[#FFC700]' : 'text-[#1B2D8C]/65 hover:text-[#1B2D8C]'}`}>
              <span className="font-mono text-[9px] tracking-[0.32em] opacity-50 group-hover:opacity-100">{r.no}</span>
              <span className="font-sans text-base">{r.label}</span>
            </button>
          ))}
        </nav>
        <button onClick={() => setPage('brief')} data-testid="vsp-header-brief" className="hidden md:inline-block bg-[#1B2D8C] text-[#FFC700] font-mono text-[10px] tracking-[0.32em] uppercase px-5 py-2.5 hover:bg-[#FFC700] hover:text-[#1B2D8C] transition-colors">Send a brief →</button>
      </div>
    </header>
  );
}
